<div class="header-bar">
  <h1>Cancellation Statuses</h1>
</div>
<div class="">
  <div class="content-container">
    <p-table
      [value]="cancellationStatuses"
      [(selection)]="selectedCancellationStatus"
      [rows]="50"
      paginator="true"
      selectionMode="single"
      dataKey="id"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5rem"></th>
          <th pSortableColumn="name">Reason</th>
          <th pSortableColumn="description">Description</th>
          <th pSortableColumn="isActive">Active</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-status let-expanded="expanded">
        <tr (dblclick)="editCancellationStatus(status)" [pSelectableRow]="status">
          <td>
            <button
              pButton
              [pRowToggler]="status"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            ></button>
          </td>
          <td>
            <span>
              {{ status.name }}
            </span>
          </td>
          <td>
            <span>
              {{ status.description }}
            </span>
          </td>
          <td style="text-align: center">
            <span *ngIf="status.isActive"><i class="fa fa-check text-success"></i></span>
            <span *ngIf="!status.isActive"><i class="fa fa-times text-error"></i></span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-status>
        <tr>
          <td colspan="4">
            <div class="p-p-3">
              <h2>Secondary Cancellation Statuses</h2>
              <p-table
                [value]="status.secondaryCancellationStatuses"
                [(selection)]="selectedSubCancellationStatus"
                selectionMode="single"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="name">Name</th>
                    <th pSortableColumn="showDescription">Show Description To Customer?</th>
                    <th pSortableColumn="showToCustomer">Show Sub Status To Customer?</th>
                    <th pSortableColumn="isActive">Active</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-subStatus>
                  <tr
                    (dblclick)="editSecondaryCancellationStatus(subStatus)"
                    [pSelectableRow]="subStatus"
                  >
                    <td>
                      <span>
                        {{ subStatus.name }}
                      </span>
                    </td>
                    <td style="text-align: center">
                      <span *ngIf="subStatus.showDescription"
                        ><i class="fa fa-check text-success"></i
                      ></span>
                      <span *ngIf="!subStatus.showDescription"
                        ><i class="fa fa-times text-error"></i
                      ></span>
                    </td>
                    <td style="text-align: center">
                      <span *ngIf="subStatus.showToCustomer"
                        ><i class="fa fa-check text-success"></i
                      ></span>
                      <span *ngIf="!subStatus.showToCustomer"
                        ><i class="fa fa-times text-error"></i
                      ></span>
                    </td>
                    <td style="text-align: center">
                      <span *ngIf="subStatus.isActive"
                        ><i class="fa fa-check text-success"></i
                      ></span>
                      <span *ngIf="!subStatus.isActive"
                        ><i class="fa fa-times text-error"></i
                      ></span>
                    </td>
                  </tr>
                </ng-template>
              </p-table>

              <div class="text-right mt-2">
                <button
                  pButton
                  label="Edit"
                  (click)="editSecondaryCancellationStatus()"
                  *ngIf="selectedSubCancellationStatus"
                ></button>
                <button
                  pButton
                  label="Add"
                  (click)="addSecondaryCancellationStatus(status)"
                ></button>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="text-right mt-2">
      <button
        pButton
        label="Edit"
        (click)="editCancellationStatus()"
        *ngIf="selectedCancellationStatus"
      ></button>
      <button pButton label="Add" (click)="addCancellationStatus()"></button>
    </div>
  </div>
</div>

<p-dialog header="Cancellation Status" [(visible)]="showEditCancellationStatus" [modal]="true">
  <form [formGroup]="cancellationStatusForm">
    <div class="ui-g-6 ui-sm-12">
      <div class="ui-g-4">
        <label for="name">Reason</label>
      </div>
      <div class="ui-g-8">
        <input
          pInputText
          name="name"
          maxlength="50"
          style="width: 100%"
          formControlName="name"
          autocomplete="off"
          id="name"
        />
      </div>
      <div class="ui-g-4">
        <label for="description">Description</label>
      </div>
      <div class="ui-g-8">
        <textarea
          pInputTextarea
          name="description"
          style="width: 100%; height: 50px"
          formControlName="description"
          autocomplete="off"
          id="description"
        ></textarea>
      </div>

      <div class="ui-g-4">
        <label>Active</label>
      </div>
      <div class="ui-g-8">
        <p-inputSwitch formControlName="isActive"></p-inputSwitch>
      </div>

      <div class="ui-g-4">&nbsp;</div>
      <div class="ui-g-8">
        <button
          (click)="saveCancellationStatus()"
          pButton
          [label]="saving ? 'Wait..' : 'Save'"
          [disabled]="saving || !cancellationStatusForm.valid"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog
  header="Secondary Cancellation Status"
  [(visible)]="showEditSubCancellationStatus"
  [modal]="true"
>
  <form [formGroup]="secondaryCancellationStatusForm">
    <div class="ui-g-12 ui-sm-12">
      <div class="ui-g-4">
        <label for="name">Name</label>
      </div>
      <div class="ui-g-8">
        <input
          pInputText
          name="name"
          maxlength="50"
          style="width: 100%"
          formControlName="name"
          autocomplete="off"
        />
      </div>
    </div>
    <div class="ui-g-12 ui-sm-12">
      <div class="ui-g-4">
        <label>Cancellation Status</label>
      </div>
      <div class="ui-g-8">
        <p-dropdown
          placeholder="Select Cancellation Status"
          [options]="cancellationStatusesSelectionItems"
          formControlName="cancellationStatusId"
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12 ui-sm-12">
      <div class="ui-g-4">
        <label>Show Description To Customer?</label>
      </div>
      <div class="ui-g-8">
        <p-inputSwitch formControlName="showDescription"></p-inputSwitch>
      </div>
    </div>
    <div class="ui-g-12 ui-sm-12">
      <div class="ui-g-4">
        <label>Show Sub Status To Customer?</label>
      </div>
      <div class="ui-g-8">
        <p-inputSwitch formControlName="showToCustomer"></p-inputSwitch>
      </div>
    </div>
    <div class="ui-g-12 ui-sm-12">
      <div class="ui-g-4">
        <label>Active</label>
      </div>
      <div class="ui-g-8">
        <p-inputSwitch formControlName="isActive"></p-inputSwitch>
      </div>
    </div>
    <div class="ui-g-4">&nbsp;</div>
    <div class="ui-g-8">
      <button
        (click)="saveSecondaryCancellationStatus()"
        pButton
        [label]="subStatusSaving ? 'Wait..' : 'Save'"
        [disabled]="subStatusSaving || !secondaryCancellationStatusForm.valid"
      ></button>
    </div>
  </form>
</p-dialog>
<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Yes"
  rejectLabel="No"
></p-confirmDialog>
